<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteConfirmationDialog"
    :title="$t('receipts.deleteDialog.title')"
    :confirm-text="$t('receipts.deleteDialog.confirm')"
    confirm-variant="danger"
    :loading="loading"
    @confirm="confirmAction"
  >
    <template #body>
      <p>
        {{ $t('receipts.deleteDialog.body', { receiptNumber }) }}
      </p>
      <p class="text-warning">
        {{ $t('receipts.deleteDialog.warning') }}
      </p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineProps, defineExpose, defineEmits } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

defineProps({
  receiptNumber: String
});


const emit = defineEmits(['confirm']);
const baseDialog = ref(null);
const loading = ref(false);

const show = () => {
  baseDialog.value.openDialog();
};

const hide = () => {
  baseDialog.value.closeDialog();
};

const confirmAction = async () => {
  loading.value = true;
  try {
    emit('confirm');
    hide();
  } finally {
    loading.value = false;
  }
};

defineExpose({ show, hide });
</script>